import React from 'react';
import { useStore } from './useStore';
import { Navigate, useLocation } from 'react-router-dom';
import { ekDomain, ROUTES } from '@/configs/constants';
import { isPathEk } from '@/utils/routes';

// props
interface WithAuthenticationProps {
}

export default function withAuthentication<P extends object>(
    WrappedComponent: React.ComponentType<P>
) {
    const WithAuthentication = (props: P & WithAuthenticationProps): React.ReactElement => {
        const { pathname } = useLocation();
        const isEk = isPathEk(pathname);
        // store
        const {
            authStore: { tokenGas, tokenEk }
        } = useStore();

        if (isEk) {
            if (!tokenEk) return <Navigate to={`/${ekDomain}${ROUTES.signin.href}`} state={{ previousUrl: `${window.location.href}` }} />;
        } else {
            if (!tokenGas) return <Navigate to={ROUTES.signin.href} state={{ previousUrl: `${window.location.href}` }} />;
        }

        return <WrappedComponent {...(props as P)} />;
    };

    return WithAuthentication;
}
